const disclaimerTC = `
上傳文件作為付款證明，即表示您承認並同意以下條款和條件：<br/>
<ol class="disclaimer">
<li>準確性與真實性：您確認上傳的文件準確且真實地反映了您所支付的款項。任何虛假、篡改或誤導性文件都可能導致您的證明被拒絕並產生潛在的法律後果。
<li>保密性：雖然我們採取合理措施確保您上傳文件的安全，但我們無法保證透過網路傳輸的資料完全保密。提交文件即表示您同意傳輸您的資訊並了解固有風險。
<li>驗證流程：提交文件作為付款證明並不能保證接受。每份文件都將被單獨審查以驗證付款。完成驗證過程可能需要其他資訊或文件。
<li>處理時間：驗證您的付款證明可能需要相當長的時間。感謝您在此期間的耐心和理解。一旦做出決定，我們將立即通知您結果。
<li>文件格式和品質：確保上傳的文件採用可接受的格式（例如 PDF、JPEG 或 PNG），並且品質高且清晰。文件品質不佳或不可讀可能會導致您的付款證明被拒絕。
<li>聯絡資訊：確保您的聯絡資訊準確且最新。對於因聯絡方式不正確或過時而導致的任何延誤或問題，我們概不負責。
<li>遵守法律：您同意遵守與提交付款證明相關的所有適用法律和法規。
<li>條款變更：我們保留隨時修改這些條款及條件的權利，恕不另行通知。您有責任定期檢視這些條款。繼續使用文件上傳服務即表示您接受任何變更。
<li>責任限制：在法律允許的最大範圍內，對於因使用或無法使用我們的文件上傳服務而引起的或與之相關的任何直接、間接、附帶、後果性或懲罰性損害，我們不承擔任何責任.</li></ol>
點擊「提交」並上傳您的文檔，即表示您承認您已閱讀、理解並同意這些條款和條件。`;

export default disclaimerTC;